module.exports = __webpack_public_path__ + "static/img/lniao_benefit_btn_bg.b49c77eb.png";